// extracted by mini-css-extract-plugin
export default {"item-body":"Item_item-body__SJAUR","clickable":"Item_clickable__N0Fl0"};